// extracted by mini-css-extract-plugin
export var card = "_nm-0";
export var content = "_nm-2";
export var icon = "_nm-1";